import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=8cd84020&scoped=true&"
import script from "./DropdownItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./DropdownItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DropdownItem.vue?vue&type=style&index=0&id=8cd84020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd84020",
  null
  
)

export default component.exports